import { getSpacingValueFromNumber } from './getSpacingValueFromNumber';
import type { SpacingFactorType } from './types';

export const getSpacingValue = (factor: SpacingFactorType, addPx = false) =>
  typeof factor === 'string'
    ? factor
    : getSpacingValueFromNumber(factor, addPx);
